module.exports = __webpack_public_path__ + "img/gr.gr24e4280.svg";